import React from 'react';
import PropTypes from 'prop-types'
import TextIcon from "../../Atoms/TextIcon";
import StoreGraphic from "../../../static/images/utils/store-1.svg"
import Badge from "../../Atoms/Badge";

const SubsidiaryInformationSection = (props) => {
  const {isMainSubsidiary} = props
  return (
    <section className="s-center">
      <div className="s-mb-8px s-relative s-main-center">
        <img
          className="s-w-64px s-h-64px"
          src={StoreGraphic}
        />
        {isMainSubsidiary && (
          <div className="s-main-center s-absolute s-bottom-0">
            <Badge text="Principal" />
          </div>
        )}
      </div>
      <h4 className="s-mb-16px">Sucursal Coquitos</h4>
      <div className="smaller s-main-center s-mb-24px">
        <TextIcon
          className="s-mb-8px"
          icon="pin"
          text="1901 Thornridge Cir. Shiloh, Hawaii 81063"
        />
        <div className="s-cross-center s-flex-gap-16px s-mb-16px">
          <TextIcon
            icon="cellphone"
            text="311-139-5543"
          />
          <TextIcon
            icon="home"
            text="Cofrem"
          />
        </div>
        <p className="s-mb-0">Amet minim mollit non deserunt ullamco est sit aliqua dolor do amet sint. Velit officia consequat duis enim velit mollit. </p>
      </div>
    </section>
  );
};

SubsidiaryInformationSection.propTypes = {
  isMainSubsidiary: PropTypes.bool,
}

SubsidiaryInformationSection.defaultProps = {
  isMainSubsidiary: false,
}

export default SubsidiaryInformationSection;
